"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WelcomeBackLayer = void 0;
var GameVars_1 = require("../../../GameVars");
var Utils_1 = require("../../../utils/Utils");
var BoardManager_1 = require("../BoardManager");
var AudioManager_1 = require("../../../AudioManager");
var WelcomeBackLayer = /** @class */ (function (_super) {
    __extends(WelcomeBackLayer, _super);
    function WelcomeBackLayer(scene) {
        var _this = _super.call(this, scene) || this;
        var darkBackground = new Phaser.GameObjects.Graphics(_this.scene);
        darkBackground.fillStyle(0x321B38);
        darkBackground.fillRect(0, 0, GameVars_1.GameVars.gameWidth, GameVars_1.GameVars.gameHeight);
        darkBackground.alpha = .6;
        _this.add(darkBackground);
        var scaledItemsContainer = new Phaser.GameObjects.Container(_this.scene, GameVars_1.GameVars.gameWidth / 2, GameVars_1.GameVars.gameHeight / 2);
        scaledItemsContainer.scaleY = GameVars_1.GameVars.scaleY;
        _this.add(scaledItemsContainer);
        var frame = new Phaser.GameObjects.Image(_this.scene, 0, 0, "texture_atlas_1", "message_box");
        scaledItemsContainer.add(frame);
        var titleBackground = new Phaser.GameObjects.Image(_this.scene, 0, -200, "texture_atlas_0", "title_cookie_base");
        scaledItemsContainer.add(titleBackground);
        var title = new Phaser.GameObjects.Image(_this.scene, 0, titleBackground.y, "texture_atlas_1", "title_welcome");
        scaledItemsContainer.add(title);
        var youWonText = new Phaser.GameObjects.Text(_this.scene, 0, -60, GameVars_1.GameVars.gameText[GameVars_1.GameVars.language]["YOU_WON"] + ":", { fontFamily: "Baloo", fontSize: "50px", color: "#95573f" });
        youWonText.setOrigin(.5);
        scaledItemsContainer.add(youWonText);
        var earnedCoinsText = new Phaser.GameObjects.Text(_this.scene, -20, 0, GameVars_1.GameVars.formatNumber(GameVars_1.GameVars.earnedCoins), { fontFamily: "Baloo", fontSize: "70px", color: "#fed344" });
        earnedCoinsText.setOrigin(.5);
        earnedCoinsText.setStroke("#95573f", 10);
        scaledItemsContainer.add(earnedCoinsText);
        var coinsIcon = new Phaser.GameObjects.Image(_this.scene, earnedCoinsText.x + earnedCoinsText.width / 2 + 30, earnedCoinsText.y + 2, "texture_atlas_1", "info_gold_icon");
        scaledItemsContainer.add(coinsIcon);
        var nextButton = new Utils_1.Button(_this.scene, 0, 140, "texture_atlas_1", "btn_ok_off", "btn_ok_on");
        nextButton.onDown(_this.onClickNext, _this);
        scaledItemsContainer.add(nextButton);
        nextButton.alpha = 0;
        _this.scene.tweens.add({
            targets: nextButton,
            y: 110,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500,
            delay: 1250
        });
        _this.alpha = 0;
        _this.scene.tweens.add({
            targets: _this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350,
            delay: 500
        });
        AudioManager_1.AudioManager.playSound("new_recipe_appears");
        return _this;
    }
    WelcomeBackLayer.prototype.onClickNext = function () {
        BoardManager_1.BoardManager.hideWelcomeBackLayer();
        AudioManager_1.AudioManager.playSound("click_button");
    };
    return WelcomeBackLayer;
}(Phaser.GameObjects.Container));
exports.WelcomeBackLayer = WelcomeBackLayer;
